export default class TagParent {
	id: number;
	name: string;
	type: string;

	constructor(json: any) {
		this.id = json.id ?? 0;
		this.name = json.name ?? '';
		this.type = json.type ?? '';
	}
}
